import { Button } from "@progress/kendo-react-buttons";
import { useNavigate } from "react-router";
import { Typography } from "@progress/kendo-react-common";
import emptyStateImage from "src/images/emptyStateImage.svg";
import * as styles from "./CatchAll.css.ts";

export default function CatchAll() {
  const navigate = useNavigate();

  return (
    <div className={styles.pageContainer}>
      <div className={styles.contentCard}>
        <div className={styles.imageContainer}>
          <img src={emptyStateImage} alt="Page not found" />
        </div>
        <Typography.p className={styles.errorCode}>404</Typography.p>
        <Typography.h2 className={styles.title}>Page not found</Typography.h2>
        <Typography.p className={styles.description}>
          The page you&apos;re looking for doesn&apos;t exist or may have been
          moved.
        </Typography.p>
        <div className={styles.actions}>
          <Button fillMode="outline" onClick={() => navigate(-1)}>
            Go back
          </Button>
          <Button themeColor="primary" onClick={() => navigate("/")}>
            Go to home
          </Button>
        </div>
      </div>
    </div>
  );
}
